export default __webpack_public_path__ + "static/media/explore-no-img.371963ec.jpg";